import {AnalyticsEventHandler} from "../../infrastructure/handlers/analytics-event-handler";
import {ACTION_TYPES} from "../consts";
import {AnalyticsService} from "../../third-party-services/analytics/analytics-service";
import {EntityClickEvent} from "../models/events/entity-click-event";

export class EntityClickEventHandler extends AnalyticsEventHandler {
  analyticsService: AnalyticsService;
  type = ACTION_TYPES.entityClick;

  static injectables = [AnalyticsService];

  constructor(analyticsService: AnalyticsService) {
    super(analyticsService);

    this.eventType = EntityClickEvent;
  }

  async action(params) {
    const currentLinkModelName = params?.currentLinkModel?.name;

    const clickEvent: EntityClickEvent = new EntityClickEvent(params, this.getScreen(currentLinkModelName), this.getScreenId(params.currentLinkModel));

    this.analyticsService.createEvent(clickEvent);
  }
}
